exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Nav{display:flex}.Nav .Nav__link{display:inline-block;flex:1 1 auto}.Nav .Nav__link.active{font-weight:bold}", ""]);
